module.exports = {
          srcSet: "/_next/static/images/img-sports@2x-160-785eb2bd0f2d670015bb05e1a28902ff.jpg"+" 160w"+","+"/_next/static/images/img-sports@2x-292-d5e737383614bd541a42f7a5737cd53b.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-sports@2x-160-785eb2bd0f2d670015bb05e1a28902ff.jpg",width: 160,height: 137},{path: "/_next/static/images/img-sports@2x-292-d5e737383614bd541a42f7a5737cd53b.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-sports@2x-160-785eb2bd0f2d670015bb05e1a28902ff.jpg",
          toString:function(){return "/_next/static/images/img-sports@2x-160-785eb2bd0f2d670015bb05e1a28902ff.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }